import { PhoneOption } from 'src/app/pages/phones/models/phone-option.interface';

export function filterPhoneOption(types: PhoneOption[], searchText: string | null | undefined): PhoneOption[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const normalizedSearchText = term.replace(/\s+/g, '');
      const upper = normalizedSearchText.toUpperCase();
      return types.filter((item) => {
         if (item.phoneType === 'Softphone') {
            return (
               item.sipUsers?.some((sipUser) => sipUser.userName.replace(/\s+/g, '').toUpperCase().includes(upper)) ||
               (item.phoneType && item.phoneType.replace(/\s+/g, '').toUpperCase().includes(upper))
            );
         } else if (item.phoneType === 'Hardphone') {
            return (
               item.devices?.some((device) => device.macAddress.replace(/\s+/g, '').toUpperCase().includes(upper)) ||
               (item.phoneType && item.phoneType.replace(/\s+/g, '').toUpperCase().includes(upper))
            );
         }
      });
   } else {
      return types || [];
   }
}
